export const products = {
  breadcrumb: {
    overview: 'Producten',
    create: 'Product aanmaken',
    edit: 'Product bewerken',
  },
  alerts: {
    successCreated: 'Je product werd succesvol verzonden ter goedkeuring!',
    successDeleted: 'Het product werd succesvol verwijderd!',
    successUpdated: 'Het product werd succesvol aangepast!',
  },
  createEdit: {
    blocker: {
      create: 'Ben je zeker dat je de pagina wilt verlaten? Je product werd nog niet aangemaakt.',
      edit: 'Ben je zeker dat je de pagina wilt verlaten? Je wijzigingen worden alleen bewaard als je het product aanmaakt.',
    },
    details: {
      title: 'Product details',
    },
    info: {
      description: 'Vul hier de informatie van jouw product in',
      title: 'Basis informatie',
    },
    submit: {
      create: 'Maak product aan',
      edit: 'Bewerk product',
      save: 'Opslaan',
    },
    title: {
      create: 'Nieuw product',
      edit: 'Bewerk product',
    },
  },
  fields: {
    activityType: {
      label: 'Soort prestatie',
      placeholder: 'Kies een soort prestatie',
      tooltip:
        'Selecteer welk type prestatie van toepassing is. <a href="https://knowledge.creativeshelter.be/wanneer-moet-je-welke-soort-prestatie-aanduiden">Hier kan je raadplegen welke prestatie wanneer van toepassing is.</a>',
    },
    categories: {
      label: 'Categorieën',
      placeholder: 'Voeg hier een categorie toe',
    },
    name: {
      inLanguage: {
        en: 'Productnaam engels',
        fr: 'Productnaam frans',
        nl: 'Productnaam nederlands',
      },
      label: 'Productnaam',
      placeholder: 'Productnaam',
    },
    price: {
      label: 'Prijs (excl. btw)',
      tooltip:
        'Gebruik je vaak dezelfde prijs voor je product? Vul deze al in, bespaar jezelf wat werk. Je kan deze nog wijzigen wanneer je je factuur opstelt.',
    },
    unit: {
      label: 'Eenheid',
      placeholder: 'Kies een eenheid',
      tooltip:
        'Gebruik je vaak dezelfde eenheid voor je product? Vul deze al in en bespaar jezelf wat werk. Je kan deze nog wijzigen wanneer je je factuur opstelt.',
    },
  },
  header: {
    actionBlock: {
      button: 'Product aanmaken',
    },
    title: 'Producten',
  },
  modal: {
    add_one: '{{count}} product toevoegen',
    add_other: '{{count}} producten toevoegen',
    add_zero: 'Product(en) toevoegen',
    createNew: 'Nieuw product aanmaken',
    title: 'Product(en) toevoegen',
  },
  overview: {
    infoCard: {
      title: 'Informatie over producten',
      products: {
        title: 'Wat zijn producten',
        description:
          'Een product is een factuurlijn die je vooraf aanmaakt en daarna steeds opnieuw gebruikt op een factuur of offerte, zonder elke keer van nul te beginnen.',
        href: '#',
        label: 'Meer informatie',
      },
      instantInvoices: {
        title: 'Instant factureren',
        description:
          'Wij controleren elk nieuw product. Is het goedgekeurd? Dan stellen we bij gebruik op een factuur geen vragen meer. En een factuur met alleen goedgekeurde producten kan zelfs een instant factuur worden.',
        href: '#',
        label: 'Meer informatie',
      },
    },
    columns: {
      creativeWork: 'Type',
      name: 'Productnaam',
      price: 'Prijs',
      productCategories: 'Categorieën',
      status: {
        options: {
          Approved: 'Goedgekeurd',
          InReview: 'Ter goedkeuring',
          Rejected: 'Afgewezen',
        },
        title: 'Status',
      },
    },
    deleteModal: {
      description: 'Ben je zeker dat je dit product wilt verwijderen?',
      title: 'Product verwijderen',
    },
  },
};
